/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetLandlordShortResponseDto } from './AssetLandlordShortResponseDto';
import {
    AssetLandlordShortResponseDtoFromJSON,
    AssetLandlordShortResponseDtoFromJSONTyped,
    AssetLandlordShortResponseDtoToJSON,
    AssetLandlordShortResponseDtoToJSONTyped,
} from './AssetLandlordShortResponseDto';
import type { AssetModelShortResponseDto } from './AssetModelShortResponseDto';
import {
    AssetModelShortResponseDtoFromJSON,
    AssetModelShortResponseDtoFromJSONTyped,
    AssetModelShortResponseDtoToJSON,
    AssetModelShortResponseDtoToJSONTyped,
} from './AssetModelShortResponseDto';
import type { ConnectivityStatus } from './ConnectivityStatus';
import {
    ConnectivityStatusFromJSON,
    ConnectivityStatusFromJSONTyped,
    ConnectivityStatusToJSON,
    ConnectivityStatusToJSONTyped,
} from './ConnectivityStatus';
import type { EvseType } from './EvseType';
import {
    EvseTypeFromJSON,
    EvseTypeFromJSONTyped,
    EvseTypeToJSON,
    EvseTypeToJSONTyped,
} from './EvseType';
import type { AssetPlanShortResponseDto } from './AssetPlanShortResponseDto';
import {
    AssetPlanShortResponseDtoFromJSON,
    AssetPlanShortResponseDtoFromJSONTyped,
    AssetPlanShortResponseDtoToJSON,
    AssetPlanShortResponseDtoToJSONTyped,
} from './AssetPlanShortResponseDto';
import type { AssetTypeShortResponseDto } from './AssetTypeShortResponseDto';
import {
    AssetTypeShortResponseDtoFromJSON,
    AssetTypeShortResponseDtoFromJSONTyped,
    AssetTypeShortResponseDtoToJSON,
    AssetTypeShortResponseDtoToJSONTyped,
} from './AssetTypeShortResponseDto';

/**
 * 
 * @export
 * @interface AssetListItemResponseDto
 */
export interface AssetListItemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetListItemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetListItemResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetListItemResponseDto
     */
    serialNumber: string;
    /**
     * Organization business identifier (e.g. CH-001)
     * @type {string}
     * @memberof AssetListItemResponseDto
     */
    tenantAssetId: string | null;
    /**
     * ISO installation timestamp when known; null when unset.
     * @type {Date}
     * @memberof AssetListItemResponseDto
     */
    installedAt: Date | null;
    /**
     * 
     * @type {AssetModelShortResponseDto}
     * @memberof AssetListItemResponseDto
     */
    assetModel: AssetModelShortResponseDto | null;
    /**
     * 
     * @type {AssetTypeShortResponseDto}
     * @memberof AssetListItemResponseDto
     */
    assetType: AssetTypeShortResponseDto;
    /**
     * 
     * @type {EvseType}
     * @memberof AssetListItemResponseDto
     */
    standard: EvseType | null;
    /**
     * Linked landlord organization, if assigned
     * @type {AssetLandlordShortResponseDto}
     * @memberof AssetListItemResponseDto
     */
    landlord: AssetLandlordShortResponseDto | null;
    /**
     * Active preventive maintenance plan, if assigned (Step 1: at most one)
     * @type {AssetPlanShortResponseDto}
     * @memberof AssetListItemResponseDto
     */
    preventivePlan: AssetPlanShortResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof AssetListItemResponseDto
     */
    incidentsCount: number;
    /**
     * 
     * @type {number}
     * @memberof AssetListItemResponseDto
     */
    expectedDailyEarning: number;
    /**
     * 
     * @type {number}
     * @memberof AssetListItemResponseDto
     */
    calculatedDailyEarning: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetListItemResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetListItemResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AssetListItemResponseDto
     */
    chargerAuthenticationConfigured: boolean;
    /**
     * Last frame received from the charger (any channel). Live value from Redis, else the archived value.
     * @type {Date}
     * @memberof AssetListItemResponseDto
     */
    lastSeenAt: Date | null;
    /**
     * ONLINE / OFFLINE for monitored chargers; UNKNOWN when the platform cannot measure right now; null when the asset is not monitored.
     * @type {ConnectivityStatus}
     * @memberof AssetListItemResponseDto
     */
    connectivityStatus: ConnectivityStatus | null;
}



/**
 * Check if a given object implements the AssetListItemResponseDto interface.
 */
export function instanceOfAssetListItemResponseDto(value: object): value is AssetListItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('tenantAssetId' in value) || value['tenantAssetId'] === undefined) return false;
    if (!('installedAt' in value) || value['installedAt'] === undefined) return false;
    if (!('assetModel' in value) || value['assetModel'] === undefined) return false;
    if (!('assetType' in value) || value['assetType'] === undefined) return false;
    if (!('standard' in value) || value['standard'] === undefined) return false;
    if (!('landlord' in value) || value['landlord'] === undefined) return false;
    if (!('preventivePlan' in value) || value['preventivePlan'] === undefined) return false;
    if (!('incidentsCount' in value) || value['incidentsCount'] === undefined) return false;
    if (!('expectedDailyEarning' in value) || value['expectedDailyEarning'] === undefined) return false;
    if (!('calculatedDailyEarning' in value) || value['calculatedDailyEarning'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('chargerAuthenticationConfigured' in value) || value['chargerAuthenticationConfigured'] === undefined) return false;
    if (!('lastSeenAt' in value) || value['lastSeenAt'] === undefined) return false;
    if (!('connectivityStatus' in value) || value['connectivityStatus'] === undefined) return false;
    return true;
}

export function AssetListItemResponseDtoFromJSON(json: any): AssetListItemResponseDto {
    return AssetListItemResponseDtoFromJSONTyped(json, false);
}

export function AssetListItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetListItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'],
        'tenantAssetId': json['tenantAssetId'],
        'installedAt': (json['installedAt'] == null ? null : new Date(json['installedAt'])),
        'assetModel': AssetModelShortResponseDtoFromJSON(json['assetModel']),
        'assetType': AssetTypeShortResponseDtoFromJSON(json['assetType']),
        'standard': EvseTypeFromJSON(json['standard']),
        'landlord': AssetLandlordShortResponseDtoFromJSON(json['landlord']),
        'preventivePlan': AssetPlanShortResponseDtoFromJSON(json['preventivePlan']),
        'incidentsCount': json['incidentsCount'],
        'expectedDailyEarning': json['expectedDailyEarning'],
        'calculatedDailyEarning': json['calculatedDailyEarning'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'chargerAuthenticationConfigured': json['chargerAuthenticationConfigured'],
        'lastSeenAt': (json['lastSeenAt'] == null ? null : new Date(json['lastSeenAt'])),
        'connectivityStatus': ConnectivityStatusFromJSON(json['connectivityStatus']),
    };
}

export function AssetListItemResponseDtoToJSON(json: any): AssetListItemResponseDto {
    return AssetListItemResponseDtoToJSONTyped(json, false);
}

export function AssetListItemResponseDtoToJSONTyped(value?: AssetListItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'tenantAssetId': value['tenantAssetId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'assetModel': AssetModelShortResponseDtoToJSON(value['assetModel']),
        'assetType': AssetTypeShortResponseDtoToJSON(value['assetType']),
        'standard': EvseTypeToJSON(value['standard']),
        'landlord': AssetLandlordShortResponseDtoToJSON(value['landlord']),
        'preventivePlan': AssetPlanShortResponseDtoToJSON(value['preventivePlan']),
        'incidentsCount': value['incidentsCount'],
        'expectedDailyEarning': value['expectedDailyEarning'],
        'calculatedDailyEarning': value['calculatedDailyEarning'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'chargerAuthenticationConfigured': value['chargerAuthenticationConfigured'],
        'lastSeenAt': value['lastSeenAt'] == null ? value['lastSeenAt'] : value['lastSeenAt'].toISOString(),
        'connectivityStatus': ConnectivityStatusToJSON(value['connectivityStatus']),
    };
}

